import { PREPOPULATE_MILEAGE_KEY } from '../types/dealerConfig.types';
import type { DealerConfigSetting } from '../types/dealerConfig.types';
import { readBooleanSetting } from './readBooleanSetting';

/** Resolve the dealer's mileage pre-population flag from its raw config settings (#789). */
export function resolvePrepopulateMileage(
    settings?: DealerConfigSetting[] | null,
): boolean {
    return readBooleanSetting(settings, PREPOPULATE_MILEAGE_KEY);
}
